__turbopack_context__.v({
  "cards": "EXuTcq_cards",
  "content": "EXuTcq_content",
  "headContact": "EXuTcq_headContact",
  "p": "EXuTcq_p",
  "page-body-wrap": "EXuTcq_page-body-wrap",
  "pagehero": "EXuTcq_pagehero",
  "paragraph": "EXuTcq_paragraph",
  "paragraph-content": "EXuTcq_paragraph-content",
  "paragraph2": "EXuTcq_paragraph2",
  "phonecontent": "EXuTcq_phonecontent",
  "store": "EXuTcq_store",
  "t": "EXuTcq_t",
  "title": "EXuTcq_title",
  "wrap-container": "EXuTcq_wrap-container",
  "wrap-content": "EXuTcq_wrap-content",
});
